<template>
<div class="chapter">
<div class="inner_page">
<p class="SP1"> </p>
<p class="EP">The difference between a fairy tale and a truck driver’s story is that the fairy tale starts with “Once upon a time,” whereas the truck driver’s story starts, “You ain’t gonna believe this…”</p>
<p class="EPC"><span class="ePub-BI">—AN OLD TRUCKER SAYING</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?f0897350